<template>
  <div :class="['col-md-12', 'status-message', statusType && `status-message--${statusType}`]">
    <slot>
      {{ message }}
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    statusType: {
      type: String,
      required: true,
      validator: value => ['success', 'error', 'warning', 'info'].includes(value),
    },
  },
};
</script>

<style scoped lang="scss">
@import './StatusBar.scss';
</style>
